import React, { useEffect, useRef, useState } from 'react';
import { Button } from '@mui/material';
import { Link } from "react-router-dom";
import { getProperties } from "../../../services/api/property";
import { showSnackbar } from '../../../Components/Notification/Snackbar';
import 'swiper/swiper-bundle.min.css';
import 'swiper/swiper.min.css';
import { Navigation, Autoplay, Pagination } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';

import SVGIcons from '../../../assets/images/icons/svgIcons';

import './propertyList.scss';
import { formURLSlug } from '../../../helpers/helper.functions';
import S3ImageViewerWithFallback from '../../awsS3ImageViewer/ImgViewerWithFallback';



function PropertyList() {

  const [data, setData] = useState([]);
  const [type, setType] = useState('sell');
  const [isLoading, setIsLoading] = useState(true);
  /**
  the legendary use effect function
  This will run very first on render
   */
  useEffect(() => {
    getPropertiesAs()
    return () => {
      setData([])
    };
    // eslint-disable-next-line
  }, [type]);

  // get users from api
  const getPropertiesAs = () => {
    setIsLoading(true);
    const filter = type !== 'all' ? { operationType: type, limit: 1000 } : undefined;
    getProperties(filter)
      .then(({ data }) => setData(data))
      .catch(() => showSnackbar().failure('Something went wrong'))
      .finally(() => setIsLoading(false))

  }

  const generateSlug = (title) => formURLSlug(title);


  // eslint-disable-next-line react/prop-types
  const CustomPrevButton = ({ onClick }) => (
    <button type='button' className="swiper-button-prev" onClick={onClick}>
      <SVGIcons.LeftArrowIcon />
    </button>
  );
  // eslint-disable-next-line react/prop-types
  const CustomNextButton = ({ onClick }) => (
    <button type='button' className="swiper-button-next" onClick={onClick}>
      <SVGIcons.RightArrowIcon />
    </button>
  );
  const swiperRef = useRef(null);


  return (
    <>
      <div className="item-listing-wrp f-wrp">
        <br />
        <div className='filter-btns f-wrp' style={{ display: 'none' }}>
          {['all', 'sell', 'rent'].map((btn) => <Button onClick={() => setType(btn)} className={`pln-btn ${type === btn ? 'active' : ''}`}>{btn}</Button>)}
        </div>
        {(isLoading) ? <span className='property-loader'> <SVGIcons.LoaderIcon /></span> :
          (!isLoading && data.length === 0) ? <span className='property-loader'> No Results found </span> :
            <>
              <Swiper
                onSwiper={(swiper) => { swiperRef.current = swiper; }}
                modules={[Navigation, Autoplay, Pagination]}
                spaceBetween={30}
                slidesPerView={3}
                pagination={{
                  el: '.swiper-pagination-custom',
                  clickable: true,
                  dynamicBullets: true,
                  dynamicMainBullets: 3,
                }}
                className='property-slider f-wrp'
                navigation={{
                  nextEl: '.swiper-button-next',
                  prevEl: '.swiper-button-prev',
                }}
                autoplay={{
                  delay: 2500,
                  disableOnInteraction: false,
                }}
                loop
                breakpoints={{
                  0: {
                    slidesPerView: 1,
                    spaceBetween: 0,
                    navigation: true,
                    autoplay: true,
                  },
                  640: {
                    slidesPerView: 2,
                    spaceBetween: 20,
                    navigation: true,
                    autoplay: true,
                  },
                  768: {
                    slidesPerView: 2,
                    spaceBetween: 20,
                    navigation: true,
                    autoplay: true,
                  },
                  1024: {
                    slidesPerView: 3,
                    spaceBetween: 20,
                    navigation: true,
                  },
                  1400: {
                    slidesPerView: 4,
                    spaceBetween: 2,
                    navigation: true,
                    autoplay: false,
                  },
                }}

              >
                {data.map((element, key) => (
                  <SwiperSlide key={key} className={`${element.className}`}>
                    <div className="each-property-items property-item-revamp f-wrp" key={key}>
                      <Link to={`/property-detail/${generateSlug(element.titleSlug)}`}>
                        <div className="propList-bg f-wrp">
                          {element.images.length > 0 ? <img src={element.images[0].tempURL} alt={`${element.title}`} /> : ''}
                          <div className='labels'>
                            {(element?.isNewListing) ? <span className='propLabel newList'><SVGIcons.NewHomeIcon /> Exclusive</span> : null}
                            {(element?.isDiscountedPrice) ? <span className='propLabel discount-price'><SVGIcons.DollarIcon /> Distress Property</span> : null}
                          </div>
                          {element.permitQRCode ? <span className='absolute-qr-code'><S3ImageViewerWithFallback fileKey={element.permitQRCode} /></span> : null}


                        </div>
                        <div className="propList-item-blk f-wrp">
                          <div className='each-item-blk'>
                            <p><b>{element.title}</b></p>
                            {element.subTitle && <p className='subTitle'><b>{element.subTitle}</b></p>}
                            <h1>{element.price} AED</h1>
                            <p className='location'><SVGIcons.MapPinIcon /> {element.location}</p>
                            <ul className="detail-list">
                              {element.noOfBedrooms ? <li><span><SVGIcons.BedIcon /> {`${element.noOfBedrooms} ${element.noOfBedrooms === 'Studio' ? '' : 'Beds'}`}</span></li> : null}
                              {element.noOfBathrooms ? <li><span><SVGIcons.BathIcon /> {`${element.noOfBathrooms} Bath`}</span></li> : null}
                              {element.bua ? <li><span><SVGIcons.BuaIcon /> BUA: {`${element.bua} SqFt`}</span></li> : null}
                            </ul>
                          </div>
                          <div className='each-item-blk'>

                            <ul className='card-foot-btn'>
                              <li>
                                <div className="contct-btn-sec f-wrp">
                                  <div className="whstapp-btn" onClick={() => (window.location.href = 'tel:+971568816886')} ><SVGIcons.CallIcon /> Call</div>
                                </div>
                              </li>
                              <li>
                                <div className="contct-btn-sec f-wrp">
                                  <div className="whstapp-btn" onClick={() => window.open('https://wa.me/971568816886', '_blank')}><SVGIcons.WhatsappIcon /><span>Whatsapp</span></div>
                                </div>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </Link>
                    </div>
                  </SwiperSlide>
                ))}
              </Swiper>
              <div className="swiper-pagination-custom" style={{ paddingTop: '25px' }} />
              <CustomPrevButton onClick={() => swiperRef.current.slidePrev()} />
              <CustomNextButton onClick={() => swiperRef.current.slideNext()} />
            </>}
      </div>
    </>
  );
}

export default PropertyList;